<div class="content">
  <img src="/assets/img/resolve-logo-black.svg" alt="Resolve" class="logo" />
  <h1 class="title">Practice Portal</h1>
  <button lib-button theme="primary" (click)="userService.login()">Sign In</button>
</div>
